const renames: Record<string, Record<string, string>> = {
  // Map HubSpot property names to the reserved identify trait names
  // listed in https://docs.customer.io/cdp/sources/source-spec/identify-spec/#traits
  //
  // Only includes fields where the HubSpot property name differs from the
  // camelCase CDP trait name. Fields like "email" and "phone" already match
  // after the dynamic "properties." prefix stripping.
  identify: {
    'properties.firstname': 'firstName',
    'properties.lastname': 'lastName',
    'properties.jobtitle': 'title',
  },

  group: {},

  relationship: {},
};

export default renames;
